// extracted by mini-css-extract-plugin
export default {"root":"LikePreview-module-root-IRJEC","overlay":"LikePreview-module-overlay-QJZry","container":"LikePreview-module-container-UIuJl","rtl":"LikePreview-module-rtl-FMKMb"};